<app-breadcrumb></app-breadcrumb>
<section class="py-5">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <ul class="nav nav-pills nav-fill mb-3 border border-primary">
                    <li class="nav-item">
                        <a class="nav-link rounded-0" [routerLink]="['/notice-board']" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact:true}">
                            ALL
                        </a>
                    </li>
                    <li *ngFor="let item of noticeBoardCategories" class="nav-item">
                        <a class="nav-link rounded-0" [routerLink]="['/notice-board', item.slug]" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact:true}">
                            {{item.name}}
                        </a>
                    </li>
                </ul>
                <div class="bg-white rounded shadow p-4 my-5">
                    <ul class="list-circle list-circle-yellow list-unstyled">
                        <li *ngFor="let v of queryResult.items" class="mb-4">
                            <app-notification-single [noticeBoard]="v"></app-notification-single>
                        </li>
                    </ul>
                    <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page"
                        [page-size]="query.pageSize">
                    </pagination>
                </div>
            </div>
            <div class="col-md-4">
                <!-- <h4 class="heading h4 fw-bold text-primary mb-4">Latest Tweets</h4>
                <app-twitter [height]="'600px'"></app-twitter> -->
            </div>
        </div>
    </div>
</section>